<!-- List of signatures -->
<div *ngIf="!deleting && !error">
  <div class="modal-body">

    <!---------------------->
    <!-- TABS             -->
    <!---------------------->
    <div style="margin: 5px;">
      <ul class="nav nav-tabs">
        <li class="nav-item" role="presentation">
          <a class="nav-link" [ngClass]="openedTab === tabs.SIGNATURE_TEXT ? 'active' : ''" href="javascript:void(0)" (click)="openedTab = tabs.SIGNATURE_TEXT">{{'Type' | translate}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a class="nav-link" [ngClass]="openedTab === tabs.SIGNATURE_PEN ? 'active' : ''" href="javascript:void(0)" (click)="openedTab = tabs.SIGNATURE_PEN; resizeCanvasWithDelay();">{{'Draw' | translate}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a class="nav-link" [ngClass]="openedTab === tabs.SIGNATURE_IMG ? 'active' : ''" href="javascript:void(0)" (click)="openedTab = tabs.SIGNATURE_IMG; addFileInputListener();">{{'Image' | translate}}</a>
        </li>
      </ul>
    </div>

    <!----------------------->
    <!-- NEW PEN SIGNATURE -->
    <!----------------------->
    <div *ngIf="openedTab === tabs.SIGNATURE_PEN">
      <div style="display:inline-block; width: 75%">
        <input class="form-control" type="hidden" [ngModelOptions]="{standalone: true}" [(ngModel)]="newPenSignatureTitle" />
      </div>
      <div id="penSigContainer" class="abx-signature-pen-preview">
        <img src="images/signature-background.png"
             style="position: absolute; left: -50000px; right: -50000px; width: 100%; height: 150px;"
             id="penSigBackground"
             (load)="editorActive = true" />
        <app-canvas-editor id="penSigCanvasObj"
                       class="editor-component"
                       style="width: 300px; height: 148px;"
                       [active]="editorActive"
                       [initialPoints]="penSignaturePoints"
                       [backgroundId]="'penSigBackground'"
                       (updatePoints)="updatePenSignaturePoints($event)"
                       [inkWidth]="penSignatureWidth"
                       [inkColor]="penSignatureColor"
                       [fromSignatureDialog]="true"
                       [container]="'penSigContainer'"
                       (abxOnDrawStart)="penDrawStarted()"
                       [refresh]="refreshPenSignature"
                           [isSigDialog]="true"></app-canvas-editor>
      </div>
      <div class="checkbox abx-signature-checkbox">
        <label>
          <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="saveSignature" [disabled]="items.length >= 3" />
          {{'SaveSignature' | translate}}
        </label>
        <button class="btn btn-default" style="float: right;" [disabled]="!penSignatureHasContent" (click)="penSignaturePoints = []; penSignatureHasContent = false;">{{'Clear' | translate}}</button>
        <div style="clear: both;"></div>
      </div>
      <div class="abx-insert-signature-footer-buttons">
        <button class="btn" (click)="cancel()">{{'Cancel' | translate}}</button>
        <button class="btn btn-default" [disabled]="!penSignatureHasContent" (click)="addPenSignature()">{{'Apply' | translate}}</button>
      </div>
    </div>

    <!------------------------->
    <!-- NEW IMAGE SIGNATURE -->
    <!------------------------->
    <div *ngIf="openedTab === tabs.SIGNATURE_IMG">
      <div style="display:inline-block; width: 75%">
        <input class="form-control" type="hidden" [ngModelOptions]="{standalone: true}" (change)="upload($event, false)"  [(ngModel)]="newTxtSignatureTitle" />
      </div>
      <div [hidden]="!(imageSignature === undefined && !imgSigLoading)" [ngClass]="{'gc-hidden': !(imageSignature === undefined && !imgSigLoading)}">
        <div class="dropHere abx-image-signature-drop-here" [ngClass]="dragClass" (click)="openFileBrowser()">
          <span class="dropSigHereOrClickToSelectFile">{{'DropSigHereOrClickToSelectFile' | translate}}</span>
          <span class="clickToSelectFile">{{'ClickToSelectFile' | translate}}</span>
        </div>
      </div>
      <div [hidden]="!(imgSigLoading)" [ngClass]="{'gc-hidden': !(imgSigLoading)}" class="abx-signature-image-preview-loading">
        <div style="height: 65px;"></div>
        <div class="loader-centered-small"></div>
      </div>
      <div [hidden]="!(imageSignature)" [ngClass]="{'gc-hidden': !(imageSignature)}" class="abx-signature-image-preview">
        <img data-src="data:image/png;base64,{{imageSignature}}" />
      </div>
      <div class="checkbox abx-signature-checkbox">
        <label>
          <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="saveSignature" [disabled]="items.length >= 3" />
          {{'SaveSignature' | translate}}
        </label>
      </div>
      <div class="abx-insert-signature-footer-buttons">
        <button class="btn" (click)="cancel()">{{'Cancel' | translate}}</button>
        <button class="btn btn-default" [disabled]="!imageSignature" (click)="addImageSignature()">{{'Apply' | translate}}</button>
      </div>
    </div>

    <!------------------------->
    <!-- NEW TEXT SIGNATURE  -->
    <!------------------------->
    <div *ngIf="openedTab === tabs.SIGNATURE_TEXT">
      <div style="display:inline-block; width: 75%">
        <input class="form-control" type="hidden" [ngModelOptions]="{standalone: true}" [(ngModel)]="newTxtSignatureTitle" />
      </div>
      <input class="abx-signature-text-input" type="text" style="font-family: '{{textSignatureFamily}}'" [ngModelOptions]="{standalone: true}" [(ngModel)]="newTextSignature" placeholder="{{ 'TypeYourNameHere' | translate }}">
      <div class="checkbox abx-signature-checkbox">
        <label>
          <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="saveSignature" [disabled]="items.length >= 3" />
          {{'SaveSignature' | translate}}
        </label>
        <div class="dropdown d-inline-block abx-signatures-preview">
            <button [disabled]="!newTextSignature" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown"  id="dropdownMenuNewTextSignature" type="button" aria-haspopup="true" aria-expanded="true" title="{{'Color' | translate}}">
              <span>{{'ChangeStyle' | translate}} <span class="caret"></span></span>
            </button>
            <ul aria-labelledby="dropdownMenuNewTextSignature" class="dropdown-menu dropdown-menu-end">
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="textSignatureFamily = 'Sacramento';" style="font-family: Sacramento;">{{ newTextSignature }}</a></li>
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="textSignatureFamily = 'Allura';" style="font-family: Allura;">{{ newTextSignature }}</a></li>
              <li><a ngbDropdownItem href="javascript:void(0)" (click)="textSignatureFamily = 'Homemade Apple';" style="font-family: 'Homemade Apple';"> {{ newTextSignature }}</a></li>
            </ul>
        </div>
        <div style="clear: both;"></div>
      </div>
      <div class="abx-insert-signature-footer-buttons">
        <button class="btn" (click)="cancel()">{{'Cancel' | translate}}</button>
        <button class="btn btn-default" [disabled]="!newTextSignature" (click)="addTextSignature()">{{'Apply' | translate}}</button>
      </div>
    </div>

    <div style="display: none;">
      <form id="sigInputForm">
        <input class="form-control d-none" type="file" id="sigInput" accept=".jpg,.jpeg,.png,.gif" (change)="upload($event, false)"/>
      </form>
    </div>
  </div>
</div>

<!-- Delete confirmation window -->
<div *ngIf="deleting && !error">
  <div class="modal-header">
    <h4><span class="toolbar-icon ic-signature-saved"></span> {{'DeleteSignature' | translate}}</h4>
  </div>
  <div class="modal-body">
    <span>{{'ConfirmDeleteSignature' | translate}} <b>{{'selectedSignature' | translate}}</b>?</span>
  </div>
  <div class="modal-footer">
    <button class="btn btn-default btn-warning" style="float: left;" (click)="confirmDelete()">{{'Yes' | translate}}</button>
    <button class="btn btn-default" (click)="cancelDelete()">{{'No' | translate}}</button>
  </div>
</div>

<!-- Error has occured -->
<div *ngIf="error">
  <div class="modal-header">
    <h4><span class="toolbar-icon ic-signature-saved"></span> {{'DeleteSignature' | translate}}</h4>
  </div>
  <div class="modal-body">
    <span>{{errorMsg}}</span>
  </div>
  <div class="modal-footer">
    <button class="btn btn-default" (click)="cancel()">{{'Close' | translate}}</button>
  </div>
</div>
